module.exports = __webpack_public_path__ + "static/media/home-pre.811aae8c.811aae8c.JPG";